import { render, staticRenderFns } from "./ambulances.vue?vue&type=template&id=05c88c6d"
import script from "./ambulances.vue?vue&type=script&lang=js"
export * from "./ambulances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports